"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es/array");
require("core-js/es/array-buffer");
require("promise-polyfill/src/polyfill");
require("unorm/lib/unorm");
